import React from 'react';
import { Outlet } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import limitekTheme from '../theme/antdTheme.js';

const PublicLayout = () => (
  <ConfigProvider theme={limitekTheme}>
    <Outlet />
  </ConfigProvider>
);

export default PublicLayout;
